<template>
  <div class="tab">
    <div class="pages">
      <!-- @mouseleave="showMaintab=''" -->
      <div
        class="tab-page"
        @mouseleave="showMaintab=''" 
        v-for="(itme, i) in tablist"
        :key="i"
      >
        <div v-if="itme.name == 'Home'" class="logo-home" @click="ckOneTab($event)">
          <img src="@/assets/172-img/logo1.png" alt="" />
        </div>
        <div 
        v-else
        class="tab-text" 
        @mouseenter="showMaintab =itme.path"
        @click="goPage(itme.path),nowtab = tablist[i]"
        :class="{ setpage: $route.path == itme.path }">
        <p style="margin-bottom: 5px;white-space:break-spaces;">{{ itme.name }}</p>
        <div style="width: 100%;background-color: white;height: 2px;" v-if="$route.path== itme.path"></div>
      </div>
        <div v-if="showMaintab == itme.path && itme.min_tab" class="tab-page-list2">
          <div v-for="(data,index) in itme.min_tab" 
          :key="index"
          @click="goPage(data.path),nowtab = tablist[i],showMaintab=''"
          style="margin: 10px 0;"
          >
            <span :class="{ setpage: $route.path == data.path }">{{ data.name }}</span>
          </div>
        </div>
      </div>

    </div>
    <div class="iphone-tabs">
      <div class="iphone-tab">
        <img @click="goPage('/')" style="width: 110px;margin: auto 5px;" src="@/assets/172-img/logo.png" alt="" />
        <img @click="IphoneTabPop = true" style="width: 30px;" src="@/assets/btn/phone-tab.png" alt="">
      </div>
      <div v-if="IphoneTabPop" class="iphone-tab-pop col">
        <div v-for="(data,index) in iphoneTabList">
          <div @click="goPage(data.path),nowtab = tablist[index],showMaintab=''" style="margin: 10px 0;">
            <span :class="{ setpage: $route.path == data.path }">{{ data.name }}</span>
          </div>
        </div>
        <!-- <div @click="IphoneTabPop = false" style="color: black;font-size: 18px;font-weight: 400;background-color: azure;padding: 5px 10px;border-radius: 5px;margin-top: 20px;">< back</div> -->
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      IphoneTabPop:false,
      showMaintab:{},
      nowtab:{},
      tablist: [
        {path: "/",name: "Home"},
        // {path: "/Message",name: "ASK EDGEPROP BUDDY"},
        {path: "/",name: "PROJECT OVERVIEW"},
        {path: "/Location",name: "Location",min_tab:[{path:"/Location",name: "LOCATION MAP"},{path:"/Pano",name: "AERIAL VIEW"}]},
        {path: "/Facilities",name: "FACILITIES"},
        // {path: "/Model",name: "3D Model"},
        {path: "/FloorPlans",name: "Schematic Diagram"},
        // {path: "/Gallery",name: "Gallery",min_tab:[{path:"/Gallery",name: "PERSPECTIVES"},{path:"/Vr",name: "VIRTUAL TOUR"}]},
        {path: "/contacts",name: "Brochure"},
        {path: "/Developer",name: "Developers"},
        // {path: "/Media",name: "Social Media",min_tab:[{path:"/Map",name: "Location Map"}]},

      ],
      iphoneTabList:[
        {path: "/",name: "HOME"},
        // {path: "/",name: "Development"},
        {path:"/Location",name: "LOCATION MAP"},
        {path:"/Pano",name: "AERIAL VIEW"},
        {path: "/Facilities",name: "Facilities"},
        // {path: "/Facilities19",name: "Facilities19"},
        // {path: "/Facilities20",name: "Facilities20"},
        {path: "/FloorPlans",name: "Schematic Diagram"},
        // {path: "/Gallery",name: "Gallery"},
        // {path:"/Vr",name: "VIRTUAL TOUR"},
        {path: "/contacts",name: "Brochure"},
        {path: "/Developer",name: "Developers"},
      ]
    };
  },
  methods: {
    ckOneTab(e){
      e.stopPropagation()
      this.goPage('/');
      this.nowtab={};
      this.$emit('setVideoType',true)
    },
    goPage(pagePath) {
      // if( pagePath == '/Brochure'){
      //   return;
      // }
      this.IphoneTabPop = false
      this.$router.push(pagePath).catch((err) => {});
    },
    goMessageInfo() {
      var type = "iframe"
      var url = "https://buddy.edgeprop.sg/sora?source=audax"

      // // nwjs创建一个新窗口
      // let newWindow = nw.Window.open(url, {
      //   width: 800,
      //   height: 800,
      //   title: url,
      // });

      // // 当新窗口关闭时触发的事件
      // newWindow.on("closed", () => {
      //   newWindow = null;
      // });

      // window.open(url);

      // this.$router
      //   .push({
      //     path: '/Media',
      //     query: {
      //       mediaType: type,
      //       url:url
      //     },
      //   })
      //   .catch((err) => {});
    },
  },
  mounted() {
    console.log(this.$route);
  },
};
</script>

<style lang="less">
.tab {
  font-family: "haborocontrastnormregular", sans-serif;
  position: relative;
  width: 100%;
  height: calc(10% - 1px);
  border-top: 1px solid #9b6432;
  display: flex;
  flex-direction: row;
  z-index: 200;
  // background-color: #62828c;
  color: white;
  // background: linear-gradient(to bottom, #ffffff00, #928dab);
  .iphone-tabs{
    display: none;
  }
  .iphone-tab-pop{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #62828c;
    text-transform: uppercase;
  }
  .iphone-tab{
    width: 100%;
    display: flex;
    justify-content: space-between;
    img{
      margin: 20px;
    }
  }
  .logo-home {
    // width: 200px;
    // width: 100%;
    // height: 10vh;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    img {
      width: 180px;
      margin-top: 10px;
    }
  }
  .pages {
    width: 100%;
    display: flex;
    height: 100%;
    flex-direction: row;
    justify-content: space-around;
    .tab-page {
      position: relative;
      height: 100%;
      font-size: .8vw;
      font-weight: 500;
      margin: auto 0;
      padding: 0 20px;
      // border-right: 1px 50% solid #9a9fa1;
      text-transform: uppercase;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      .tab-text:hover,.tab-page-list2 div:hover{
        color: white !important;
      }
      .tab-page-list2{
        color: white !important;
        position: absolute;
        top: 100%;
        z-index: 999;
        left: 0;
        border-radius: 0 0 10px 10px;
        // width: 270px;
        // height: 100px;
        background-color: #0d2638;
        text-align: start;
        padding: 10px;
        white-space: nowrap;
      }
    }
    .iphone-tabs{
      display: none;
    }
  }
  .setpage {
    // color: #ebad33 !important;
    font-weight: 600;
  }
}
@media screen and (max-width:800px) {
  .pages{
    display: none !important;
  }
  .iphone-tabs{
    width: 100%;
    display: block !important;
    position: fixed;
    background-color: #0d2638;
    top: 0;
    }
}
@media screen and (max-height:800px) {
  .tab .pages .tab-page{
    font-size: 14px;
  }

}
@media screen and (max-height:500px) {
  .tab .pages .tab-page{
    font-size: .5rem;
  }

}
</style>






